import React from 'react';
import MicIcon from "@mui/icons-material/Mic";
import {ExitToApp, MicOff, SwitchVideo, Videocam, VideocamOff} from "@mui/icons-material";
import {client} from "@config/zoomClient.ts";
import {Button} from "@mui/material";
import {MediaDevice, VideoQuality} from "@zoom/videosdk";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";
import {endCall} from "@store/callSlice.tsx";
import {isMobile, isTablet} from 'react-device-detect';

const Controls = (props: {
    micOn: boolean,
    setMicOn: any,
    videoOn: boolean,
    setVideoOn: any,
    started: boolean,
    activeSpeaker: any,
    currentUser: any,
    showCallScreen: boolean,
}) => {
    const [cameraList, setCameraList] = React.useState<MediaDevice[]>([])
    const [camera, setCamera] = React.useState<number>(0)
    const dispatch = useDispatch<AppDispatch>();
    const {hasVideo} = useSelector((state: any) => state.call)


    React.useEffect(() => {
        if (hasVideo && props.started) {
            toggleVideo()
        }
    }, [hasVideo, props.started])

    React.useEffect(() => {
        const stream = client.getMediaStream()
        if (isMobile || isTablet) {
            setCameraList([
                {
                    label: 'Front Camera',
                    deviceId: 'user'
                },
                {
                    label: 'Back Camera',
                    deviceId: 'environment'
                }
            ])
        } else {
            setCameraList(stream.getCameraList())
        }
    }, [])

    React.useEffect(()=>{
        if(!props.showCallScreen){
            const stream = client.getMediaStream();
            if (props.currentUser?.userId && props.currentUser?.bVideoOn) {
                stream.attachVideo(props.currentUser.userId, VideoQuality.Video_1080P).then((userVideo: any) => {
                    document.querySelector('video-player-container[id="video-player-container-self"]')?.appendChild(userVideo)
                })
            }
        }
    },[props.showCallScreen]);

    const toggleCamera = () => {
        const stream = client.getMediaStream()
        const newIndex = (camera + 1) % cameraList.length
        stream.switchCamera(cameraList[newIndex].deviceId)
        setCamera(newIndex)
    }

    const toggleMic = () => {
        const stream = client.getMediaStream()
        if (props.micOn) {
            stream.muteAudio()
            props.setMicOn(false)
        } else {
            stream.unmuteAudio()
            props.setMicOn(true)
        }
    }
    const toggleVideo = () => {
        const stream = client.getMediaStream()
        if (props.videoOn) {
            stream.stopVideo()
            props.setVideoOn(false)
            document.querySelector(`video-player-container[id="video-player-container-self"] video-player[node-id="${props.currentUser?.userId}"]`)?.remove()
            if (props.currentUser?.userId && props.activeSpeaker?.userId === props.currentUser?.userId) {
                document.querySelector(`video-player-container[id="video-player-container-public"] video-player[node-id="${props.activeSpeaker?.userId}"]`)?.remove()
            }
        } else {
            stream.startVideo().then(() => {
                props.setVideoOn(true)
                const stream = client.getMediaStream();
                if (props.currentUser?.userId) {
                    stream.attachVideo(props.currentUser.userId, VideoQuality.Video_1080P).then((userVideo: any) => {
                        document.querySelector('video-player-container[id="video-player-container-self"]')?.appendChild(userVideo)
                    })
                }
            })
        }
    }

    const exit = () => {
        client.leave().then(() => {
            dispatch(endCall())
        })
    }
    return (
        <div className={'flex justify-center items-center py-4 gap-6'}>
            <Button variant="contained"
                    className={`bg-blue-500 !rounded-full !min-w-0 ${props.showCallScreen ? "!p-1 lg:!p-2" : "!p-3"}`}
                    aria-label={props.micOn ? 'Mic' : 'Mic Off'}
                    onClick={toggleMic}>
                {props.micOn ?
                    <MicIcon sx={{color: "white", fontSize: props.showCallScreen && {xs: "1rem", md: "1.5rem"}}}/> :
                    <MicOff sx={{color: "white", fontSize: props.showCallScreen && {xs: "1rem", md: "1.5rem"}}}/>}
            </Button>{!props.showCallScreen && <>
            <Button aria-label={props.videoOn ? 'Videocam' : 'Videocam Off'} variant="contained" className={'bg-blue-500 !rounded-full !min-w-0 !p-3'} onClick={toggleVideo}>
                {props.videoOn ? <Videocam style={{color: "white"}}/> : <VideocamOff style={{color: "white"}}/>}
            </Button>
            {
                cameraList.length > 1 && props.videoOn &&
                <Button variant="contained" className={'bg-blue-500 !rounded-full !min-w-0 !p-3'} aria-label="Switch Video"
                        onClick={toggleCamera}>
                    <SwitchVideo style={{color: "white"}}/>
                </Button>
            }</>}
            <Button variant="contained"
                    className={`!rounded-full !min-w-0  ${props.showCallScreen ? "!p-1 lg:!p-2" : "!p-3"}`} aria-label="Exit to App"
                    onClick={exit} color={'error'}>
                <ExitToApp sx={{color: "white", fontSize: props.showCallScreen && {xs: "1rem", md: "1.5rem"}}}/>
            </Button>
        </div>
    );
};

export default Controls;
